import { Grid } from '@mui/material';

import useMarkdownFile from '../../../hooks/useMarkdownFile';

interface ComputeContentProps {
  activeContent?: string;
}

const ComputeContent = ({ activeContent }: ComputeContentProps): React.JSX.Element => {
  const { markdownContent } = useMarkdownFile(activeContent ?? '');
  return <Grid item>{markdownContent}</Grid>;
};

export default ComputeContent;
